import { render } from "./SlidesPreview.vue?vue&type=template&id=6af387b9"
import script from "./SlidesPreview.vue?vue&type=script&lang=js"
export * from "./SlidesPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__